import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { bookList } from 'src/constants/bookList';
import { buildAuthLoginSearch } from 'src/routes/auth/auth.redirect';
import { isRegisteredAppPath } from 'src/routing/isRegisteredAppPath';
import NotFoundPage from 'src/routes/404';

/**
 * Catch-all for signed-out users. Registered app paths require login; everything
 * else renders the not-found page instead of forcing a login redirect.
 */
const UnauthenticatedFallbackRoute = () => {
    const { pathname, search } = useLocation();

    if (!isRegisteredAppPath(pathname)) {
        return <NotFoundPage />;
    }

    return (
        <Navigate
            to={{
                pathname: bookList.auth.login,
                search: buildAuthLoginSearch(pathname, search),
            }}
            replace
        />
    );
};

export default UnauthenticatedFallbackRoute;
